import React from "react";
import { isEmpty, template } from "lodash";
// hooks
import useMenuItems from "@/hooks/useMenuItems";
import usePages from "@/hooks/usePages";
// components
import RMDRImage from "@/components/RMDRImage";
import RMDRComponentSanitizer from "@/components/RMDRComponentSanitizer";
// types
import { TMainPageLayoutV2 } from "../type";
// enums
import EContentType from "@/cms/enums/EContentType";
import EResourceType from "@/cms/enums/EResourceType";
// interfaces
import TClientPageList from "@/cms/types/TClientPageList";
import TClientMenuItemList from "@/cms/types/TClientMenuItemList";
import TClientMainPageItemList from "@/cms/types/TClientMainPageItemList";
// utilities
import { 
    mainPageItemNameDescriptionLanguageVersion,
    menuNameDescriptionLanguageVersion,
    outerTextLanguageVersion,
    pageNameDescriptionLanguageVersion,
    redirectUrl, 
} from "@/utilities/LanguageVersionSelectorShortcut";
import RMDRLink from "@/components/RMDRLink";


const RenderItems = (props:{ payload?:TClientPageList[]|TClientMenuItemList[]|TClientMainPageItemList[]|null, languageVersionSelector:any, template?:TClientMainPageItemList }) => {
    console.log("MNPG021.RenderItems", props);

    if ( !isEmpty(props.payload) && props.payload ) {
        const languageVersion = outerTextLanguageVersion(props.template?.languageVersions, "find", undefined, EContentType.MAIN_PAGE_ITEM);
        return (
            <section className="bg-dark pt-100 pb-70">
                <div className="container">
                    <div className="section-title">
                        <h2>
                            {languageVersion?.name}
                        </h2>
                        <RMDRComponentSanitizer languageVersion={languageVersion} valueExpr="value" variant="div" />
                    </div>

                    <div className="row justify-content-center">
                        {
                            props.payload?.map((item:any, index) => {
                                const itemLanguageVersion = props.languageVersionSelector(item.languageVersions);
                                const _redirectUrl = redirectUrl(item.languageVersion)
                                const hasDestinationNavigation = item.hasDestinationNavigation ? item.hasDestinationNavigation : props.template?.hasDestinationNavigation;
                                const redirectType = item.redirectType ? item.redirectType : props.template?.redirectType;

                                return (
                                    <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12" key={item.id}>
                                        <div
                                            className="saas-services-box color-white"
                                            data-aos="fade-up"
                                            data-aos-duration="1000"
                                            data-aos-delay={100*(index+1)}
                                        >
                                            <RMDRImage 
                                                resources={item?.resources}
                                                resourceType={EResourceType.ICON}
                                                alt={itemLanguageVersion?.name}
                                                title={itemLanguageVersion?.name}
                                            />
                                            
                                            <h3>
                                                <RMDRLink
                                                    title={itemLanguageVersion?.name}
                                                    text={itemLanguageVersion?.name}
                                                    hasNavigationDestination={hasDestinationNavigation}
                                                    navigationURL={itemLanguageVersion?.contentRouteNavigationURL}
                                                    redirectType={redirectType}
                                                    redirectUrl={_redirectUrl?.value}
                                                    isShowAlways={true}
                                                    variant="div"
                                                />
                                            </h3>
                                            <RMDRComponentSanitizer languageVersion={itemLanguageVersion} valueExpr="value" variant="p" />
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </section>
        )
    }

    return null;

}

const RenderPages = (props:any) => {
    console.log("MNPG021.RenderPages", props);

    const pages = usePages({unqKey:props.unqKey, categoryId:props.categoryId});
    
    if ( !pages.payload || isEmpty(pages.payload) ) return null;

    return (<RenderItems payload={pages.payload} languageVersionSelector={pageNameDescriptionLanguageVersion} />)
}

const RenderMenuItems = (props:any) => {
    console.log("MNPG021.RenderMenuItems", props);

    const menuItems = useMenuItems(props.unqKey, props.contentLayoutName);

    if ( !isEmpty(menuItems) && menuItems ) {
        return (<RenderItems payload={menuItems} languageVersionSelector={menuNameDescriptionLanguageVersion} />)
    }

    return null;
}

const Render = (props:TMainPageLayoutV2) => {
    console.log("MNPG021.Render", props);

    if ( props.template?.isContentChildsMapped ) {
        const childs = props.templates?.filter((item) => item.mapLayoutName === props.template?.mapLayoutName && ![EContentType.MAP,EContentType.SITE_SETTING].includes(item?.contentType as number) && item.parentId === props.template?.id);
        if ( !isEmpty(childs) ) {
            return (<RenderItems payload={childs} languageVersionSelector={mainPageItemNameDescriptionLanguageVersion} template={props.template} />)
        }
    }
    else {
        const mapItem = props.templates?.find((item) => item.mapLayoutName === props.template?.mapLayoutName && item.contentType === EContentType.MAP && item.contentLayoutName?.startsWith("MNGRP_") && item.parentId === props.template?.id);
        if ( mapItem ) {
            return (<RenderMenuItems unqKey={mapItem.id.split("-")[4]} template={props.template} contentLayoutName={mapItem.contentLayoutName} />)
        }

        const categoryItem = props.templates?.find((item) => item.mapLayoutName === props.template?.mapLayoutName && item.contentType === EContentType.CATEGORY && item.parentId === props.template?.id);
        if ( categoryItem ) {
            return (<RenderPages unqKey={categoryItem.id.split("-")[4]} template={props.template} categoryId={categoryItem.contentId} />)
        }
    }

    return null;
}

const MNPG021 = ( props: TMainPageLayoutV2 ) => {
    console.log("MNPG021.rendered", props);

    return (
        <Render {...props} />
    );
}

const Component = React.memo(MNPG021, ( prevProps:TMainPageLayoutV2, nextProps:TMainPageLayoutV2 ) => {
    console.log("MNPG021.memo", { prevProps, nextProps });
    return true;
});

export default Component;
